import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { debounceTime, map, distinctUntilChanged, filter } from "rxjs/operators";
import { fromEvent } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs'
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-patient-uhid-merge-search',
    templateUrl: './patient-uhid-merge-search.component.html',
    styleUrls: ['./patient-uhid-merge-search.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: PatientUhidMergeSearchComponent,
            multi: true,
        }],
    standalone: false
})
export class PatientUhidMergeSearchComponent implements OnInit {
  @Output() selectedItemsData = new EventEmitter<any>()
  @ViewChild('textSearchInput', { static: true }) textSearchInput: ElementRef;
  resource: any;
  propagateChange = (_: any) => { };
  application: any;
  _currentData: any;
  // fields: any
  apiResponse: any;
  isSearching: boolean;
  showSuggestions: boolean = false;
  suggestionIndex: any;
  _placeholder: any;
  // _template: any = false;
  @Input() _value: any;
  queryId: any;
  projectionKeys: any;
  arguments: any;
  filters: any;
  fixLabel: any;
  inputValue: any
  returnValues: any;
  subscription: Subscription;
  capitalise: boolean = false;
  search_columns: any;
  _currentdata: any;
  items: Array<any> = [];
  selectedItems: any[] = [];
  selectedIndices: boolean[];
  selectedCount = 0;
  isChecked: number = 0;
  key: any;
  toggle: boolean = false;
  @Input()
  public set value(v: any) {
    if (v) {
      this._value = v;
    } else {
      this._value = '';
    }
  }
  @Input()
  public set placeholder(value: string) {
    if (value) {
      this._placeholder = value;
    } else {
      this._placeholder = "Select";
    }
  }

  @Input() public set data(value: any) {
    if (value) {
      console.log('value fields is as ::', value)
      this.key = value.key ? value.key : '';
      this.resource = value.datasource.resource ? value.datasource.resource : '';
      this.application = value.datasource.application ? value.datasource.application : '';
      this.fixLabel = value.fixLabel ? value.fixLabel : '';
      this.capitalise = value.capitalise ? value.capitalise : false;
      this.projectionKeys = value.datasource.projectionKeys ? value.datasource.projectionKeys : '';
      this.search_columns = value.datasource.search_columns ? value.datasource.search_columns : '';
      this.queryId = value.datasource.query_id ? value.datasource.query_id : '';
      if (value.args) {
        this.arguments = this.setArguments(value.args);
      } else {
        this.arguments = value.datasource.args ? value.datasource.args : '';
      }

      if (value.projectionKeys) {
        this.projectionKeys = this.setArguments(value.projectionKeys);
      }
      if (value['datasource']['filters']) {
        let filter: string;
        filter = value['datasource']['filters'];
        if (filter.includes(':')) {
          this.filters = filter;
        } else {
          let filterArray = filter.split(',');
          if (sessionStorage.getItem('currentData')) {
            let currentCardData = JSON.parse(sessionStorage.getItem('currentData'));
            let filterForQuery = "";
            for(let i = 0; i < filterArray.length; i++) {
              filterForQuery = filterForQuery + filterArray[i] + ":" + currentCardData[filterArray[i]] + ",";
            }
            this.filters = filterForQuery.substring(0, filterForQuery.length - 1);
          }
        }
      }

      if (value.getValues) {
        this.returnValues = value.getValues
      }
      else {
        this.returnValues = undefined;
      }
    }
  };

  @Output() patientResult = new EventEmitter<any>();
  @Output() labelEvent = new EventEmitter<any>();
  @Output() clickOutSide = new EventEmitter<any>();

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public baseService: BaseService,
    private communicationService: CommunicationService
  ) {
    this.subscription = this.communicationService.dropdownChangesEmitted$.subscribe(
      data => {
        console.log('subscription data is as ::', data)
        if (data.args) {
          this.arguments = data.args
        }
      }
    )
  }

  ngOnInit() {
    fromEvent(this.textSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(1000)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      if (text.length >= 2) {
        this.isSearching = true;
        this.searchPatient(text).subscribe((res) => {
          //let values = Object.values(this.fields);
          if (res.errCode == 0) {
            if (res.resource && res.resource.length > 0) {
              this.isSearching = false;
              this.showSuggestions = true;
              this.apiResponse = res.resource;
            }
            else {
              this.isSearching = false;
              this.showSuggestions = true;
              this.apiResponse = [];
            }
          } else {
            this.isSearching = false;
          }
        }, (err) => {
          this.isSearching = false;
        });
      } else {
        this.isSearching = false;
        this.showSuggestions = false;
        this.apiResponse = [];
      }

    });

    this.getpatientData();
  }

  getpatientData() {
    this.items = this.apiResponse;
    this.selectedIndices = [];

    if (this.items != null) {
      this.selectedIndices.length = this.items.length;
      this.selectedCount = 0;
      for (let i = 0; i < this.items.length; i++) {
        const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
        if (index > -1) {
          this.selectedCount++;
          this.selectedIndices[i] = true;
          this.selectedItems[index] = this.items[i];
        }
      }
    }
  }

  onItemChecked(checked: boolean, index: number) {
    this.checkItem(checked, index);
    if (checked) {
      this.isChecked = this.isChecked + 1;
    } else {
      this.isChecked = this.isChecked - 1;
    }
  }
  private checkItem(checked: boolean, index: number) {
    this.selectedIndices[index] = checked;
    const pos = this.selectedItems.findIndex(i => this.isSameItem(i, this.apiResponse[index]));

    if (checked) {
      if (pos === -1) {
        this.selectedCount++;
        this.selectedItems.push(this.apiResponse[index]);
      }
    } else {
      if (pos > -1) {
        this.selectedCount--;
        this.selectedItems.splice(pos, 1);
      }
    }
  }
  private isSameItem(i1: any, i2: any): boolean {
    const key = this.key;
    return this.getNestedValue(i1, key) === this.getNestedValue(i2, key);
  }
  private getNestedValue(obj: any, key: string): any {
    if (obj && key) {
      const keys = key.split('.');
      for (const k of keys) {
        obj = obj[k];
      }
      return obj;
    }
  }
  getResult(result) {
    this.selectedItemsData.emit(this.selectedItems)
    //console.log("datataaaa:", this.selectedItems);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  labelClick(event) {
    this.labelEvent.emit(event);
  }

  setArguments(args) {
    console.log('set arguments is as ::', args)
    if (Object.keys(args).length > 0) {
      var result = Object.keys(args).map(function (key) {
        return [key + ':' + args[key] ? args[key] : ""];
      });

      var merged = [].concat.apply([], result);
      return merged.join()
    }
  }


  markIsActive(index: number, result: string) {
  }

  handleSelectionClick(suggestion: any, index: any) {
    // this.suggestionIndex = index;
    // this.handleSelectSuggestion(suggestion);
    // this.hideSuggestions();
  }

  handleSelectSuggestion(suggestion: string) {
    this.textSearchInput.nativeElement.value = suggestion;
    this.propagateChange(this.suggestionIndex);
    if (this.returnValues) {
      let returnObj = this.setReturnObj(this.returnValues, this.suggestionIndex);
      this.patientResult.emit(returnObj);
    } else {
      this.patientResult.emit(this.suggestionIndex);
    }

    this.hideSuggestions();
  }

  hideSuggestions() {
    this.showSuggestions = false;
  }

  searchPatient(term: string) {
    var searchData = {
      search: term == undefined ? '' : term,
      args: this.arguments == undefined ? '' : this.arguments,
      filter: this.filters == undefined ? '' : this.filters,
      search_columns: this.search_columns == undefined ? '' : this.search_columns,
      projectionKeys: this.projectionKeys == undefined ? '' : this.projectionKeys
    };
    this.queryId = this.queryId ? this.queryId : undefined
    return this.baseService.getData(searchData, "", this.resource, this.application, this.queryId)
  }
  writeValue(value) {

  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }

  setReturnObj(value, data) {
    let obj = {};
    let objVal: any;
    if (Object.entries(value).length > 0) {
      var result = Object.entries(value).map(function (key) {
        obj = {}
        objVal = key[1];
        obj[key[0]] = data[objVal]
        return obj
      });

      return result.reduce(((r, c) => Object.assign(r, c)), {});
    }
  }
}
